import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.community.list');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcadmin-community-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.community.list/view.scss */
/* src/app/portal.gsdcadmin.community.list/view.scss: no such file or directory */`],
})
export class PortalGsdcadminCommunityListComponent implements OnInit {
    @Input() view: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        // if (this.view == "admin") await this.service.auth.allow.membership('admin', "/landing");
        // else await this.service.auth.allow(true, "/landing");
        await this.service.auth.allow("admin", "/landing");
        await this.load();
    }

    public communities: any = [];

    public async load() {
        const { code, data } = await wiz.call("load", this.search);
        if (code != 200) return await this.service.alert.error("Error!");
        this.communities = data.rows;
        await this.service.render();
    }
}

export default PortalGsdcadminCommunityListComponent;